import React from 'react'
import EmailSent from '../components/EmailVerify/EmailSent'

const EmailSentPage = () => {
  return (
    <div>
        <EmailSent />
    </div>
  )
}

export default EmailSentPage
